/*
  carousel-ada-jdgm.js
  ---------------------
  Judge.me-specific wiring on top of the generic carousel-ada.js core.
  Enhances the homepage "Let customers speak for us" reviews carousel
  (.jdgm-carousel-wrapper), which is a third-party widget injected by
  Judge.me's own external script -- we can't call into its autoplay timer or
  navigation, so this enhances the rendered DOM from the outside instead.
  Loaded after carousel-ada.js (see snippets/index-complete.liquid).
*/
document.addEventListener("DOMContentLoaded", function() {
  const carouselWrapper = document.querySelector('.jdgm-carousel-wrapper');

  if (!carouselWrapper) return;

  const labelProductLinks = (root) => {
    if (!root.querySelectorAll) return;
    const links = root.querySelectorAll('.jdgm-carousel-item__product');
    links.forEach(link => {
      if (link.getAttribute('aria-label')) return;
      const img = link.querySelector('img');
      const name = (link.dataset.adaProductName ||
        (img && img.getAttribute('alt')) ||
        link.textContent || '').trim();
      // Judge.me renders this as a non-interactive <div> wrapping the product
      // image, and aria-label is prohibited on a role-less div. role="img"
      // lets the wrapper carry the product name for the image hidden below.
      link.setAttribute('role', 'img');
      if (name) {
        link.dataset.adaProductName = name;
        link.setAttribute('aria-label', name);
      } else {
        link.setAttribute('aria-label', 'Reviewed product');
      }
    });
  };

  const cleanImages = (nodes) => {
    nodes.forEach(node => {
      // Capture product names first -- cleanImages blanks the alts they come from.
      labelProductLinks(node);
      const imgs = node.querySelectorAll ? node.querySelectorAll('img') : [];
      imgs.forEach(img => {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
        // img.setAttribute('role', 'presentation');
      });
    });
  };


  const enhanceCarousel = () => {
    if (!window.CarouselADA) return;
    const section = carouselWrapper.querySelector('.jdgm-carousel');
    if (!section || section.dataset.adaEnhanced) return;
    const items = section.querySelectorAll('.jdgm-carousel-item');
    if (!items.length) return;
    section.dataset.adaEnhanced = 'true';

    section.setAttribute('role', 'region');
    section.setAttribute('aria-roledescription', 'carousel');
    section.setAttribute('aria-label', 'Customer reviews');
    items.forEach((item, i) => {
      item.setAttribute('role', 'group');
      item.setAttribute('aria-roledescription', 'slide');
      item.setAttribute('aria-label', `Review ${i + 1} of ${items.length}`);
    });

    const track = section.querySelector('.jdgm-carousel__item-wrapper');
    const freeze = (on) => {
      if (!track) return;
      if (on) {
        let tx = 0;
        try { tx = new DOMMatrixReadOnly(getComputedStyle(track).transform).m41; } catch (e) {}
        track.style.setProperty('--jdgm-ada-tx', tx + 'px');
        track.classList.add('jdgm-ada-frozen');
      } else {
        track.classList.remove('jdgm-ada-frozen');
        track.style.removeProperty('--jdgm-ada-tx');
      }
    };

    const controller = window.CarouselADA.createController({
      playingMessage: 'Reviews carousel playing',
      pausedMessage: 'Reviews carousel paused',
      onPlay: () => freeze(false),
      onPause: () => freeze(true),
    });

    let refreezeTimer = null;
    const allowManualNav = () => {
      if (controller.isPlaying()) return;
      freeze(false);
      clearTimeout(refreezeTimer);
      refreezeTimer = setTimeout(() => {
        if (!controller.isPlaying()) freeze(true);
      }, 1200);
    };

    const onArrowActivate = (e) => {
      const t = e.target;
      if (t && t.closest && t.closest('.jdgm-carousel__left-arrow, .jdgm-carousel__right-arrow')) {
        allowManualNav();
      }
    };
    section.addEventListener('pointerdown', onArrowActivate, true);
    section.addEventListener('click', onArrowActivate, true);

    const upgradeArrow = (el, label) => {
      if (!el) return;
      el.setAttribute('role', 'button');
      el.setAttribute('aria-label', label);
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          el.click();
        }
      });
    };
    upgradeArrow(section.querySelector('.jdgm-carousel__left-arrow'), 'Previous reviews');
    upgradeArrow(section.querySelector('.jdgm-carousel__right-arrow'), 'Next reviews');

    const button = window.CarouselADA.createPausePlayButton({
      onToggle: controller.toggle,
      playLabel: 'Play reviews carousel',
      pauseLabel: 'Pause reviews carousel',
    });
    controller.setButton(button);
    carouselWrapper.appendChild(controller.liveRegion);
    const titleRow = carouselWrapper.querySelector('.jdgm-carousel-title-and-link') || carouselWrapper;
    titleRow.appendChild(button);

    window.CarouselADA.wireFocusPause(carouselWrapper, controller);

    if (window.CarouselADA.prefersReducedMotion()) {
      controller.pause({ silent: true });
    }
  };

  // Run once for whatever is present on load...
  cleanImages([carouselWrapper]);
  enhanceCarousel();

  // ...then again as Judge.me injects / finishes rendering the carousel.
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        cleanImages(mutation.addedNodes);
      }
    });
    enhanceCarousel();
  });

  observer.observe(carouselWrapper, { childList: true, subtree: true });
});